import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StatusInterfaceCMDB } from 'src/app/util/interfaces/statusInterface';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';

@Injectable({
	providedIn: 'root',
})
export class StatusCiTypeService {
	private getStatusCiTypeURL = environment.baseApiUrl + 'register/status/ciType';
	private postStatusCiTypeURL = environment.baseApiUrl + 'register/status/ciType';
	private putStatusCiTypeURL = environment.baseApiUrl + 'register/status/ciType/{id}';
	private getStatusPatternURL = environment.baseApiUrl + 'register/status/pattern';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getStatusCiType(): Observable<StatusInterfaceCMDB[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.httpClient.get<any[]>(this.getStatusCiTypeURL, { headers: headers });
	}

	postStatusCiType(data: StatusInterfaceCMDB): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			id: data.id,
			status: data.status,
			status_active: data.status_active,
			ci_type: data.ci_type,
			status_related: data.status_related,
			active: data.active,
		};

		return this.httpClient.post(this.postStatusCiTypeURL, body, { headers: headers });
	}

	putStatusCiType(data: StatusInterfaceCMDB): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putStatusCiType = this.putStatusCiTypeURL.replace('{id}', data.id);
		const body = {
			status: data.status,
			status_active: data.status_active,
			ci_type: data.ci_type,
			status_related: data.status_related,
			active: data.active,
		};

		return this.httpClient.put(putStatusCiType, body, { headers: headers });
	}

	getStatusPattern(): Observable<StatusInterfaceCMDB[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.httpClient.get<any[]>(this.getStatusPatternURL, { headers: headers });
	}
}
